export enum Actions {
    SET = 'interact-voice-set',
    RESET = 'interact-voice-reset'
}
